import { Form } from "antd";

interface Props {
  label: string;
  rules: any;
  children: React.ReactNode;
  name: string;
  className?: string;
}
const FormItem = ({ children, label, rules, name, className = "" }: Props) => {
  return (
    <Form.Item label={label} className={`${className} font-medium [&_.ant-form-item-label]:!pb-1`} name={name} rules={rules}>
      {children}
    </Form.Item>
  );
};
export default FormItem;
